import React from 'react'
import styled from 'styled-components'
import Icon from './Icon'

const S ={
    DragIcon: styled.div<{ disableSort: boolean }>`
        position: relative;
        display: flex;
        margin-bottom: 3px;
        opacity: ${({ disableSort }) => (disableSort ? 0 : 1)};
        cursor: ${({ disableSort }) => (disableSort ? 'auto' : 'move')};
        & span:last-child {
            margin-left: -17px;
        }
    `,
}

const DragIcon = ({ disableSort }: { disableSort?: boolean }) => (
    <S.DragIcon disableSort={disableSort}>
        <Icon icon="drag" size={22} color="rgba(133, 142, 156, 0.5)" />
        <Icon icon="drag" size={22} color="rgba(133, 142, 156, 0.5)" />
    </S.DragIcon>
)

export default DragIcon
